import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=4b4ef159&scoped=true"
var script = {}
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=4b4ef159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ef159",
  null
  
)

export default component.exports